import React from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { VENDORS_URL } from "@API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function VendorsListing() {
  const attributes = [{ key: "vendorName", label: "Vendor Name", flex: 2 }];
  const validationSchema = ItemValidationSchema(
    attributes[0].key,
    attributes[0].label
  );

  return (
    <GenericItemsListing
      items_URL={VENDORS_URL}
      SAVE_Item={VENDORS_URL}
      DELETE_Item={VENDORS_URL}
      title="Vendors"
      name="Vendor"
      icon={<StorefrontIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
      uniqueId="vendorId"
      isVendor
    />
  );
}

export default VendorsListing;
